var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.297,
    height: 16.297,
    viewBox: "0 0 16.297 16.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Component_19_232",
    "data-name": "Component 19 \\u2013 232",
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_473",
    "data-name": "Group 473"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1099",
    d: "M0 0h16.3v16.3H0z",
    "data-name": "Path 1099",
    style: {
      fill: "none"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_474",
    "data-name": "Group 474",
    transform: "translate(1.358 .679)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1100",
    d: "M11.507 1H3.358A1.362 1.362 0 0 0 2 2.358v9.507h1.358V2.358h8.148z",
    "data-name": "Path 1100",
    transform: "translate(-2 -1)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_475",
    "data-name": "Group 475",
    transform: "translate(4.074 3.395)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1101",
    d: "M14.827 17.223H7.358A1.362 1.362 0 0 1 6 15.865V6.358A1.362 1.362 0 0 1 7.358 5h7.469a1.362 1.362 0 0 1 1.358 1.358v9.507a1.362 1.362 0 0 1-1.358 1.358zM7.358 6.358v9.507h7.469V6.358z",
    "data-name": "Path 1101",
    transform: "translate(-6 -5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.839b2afcfc96a891de71284efdcb0f0b.svg";
export { ForwardRef as ReactComponent };